<div
    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-mb-0dot5 cmps-cdk-h-45px cmps-cdk-px-1"
>
    <div class="cmps-cdk-font-size-14p">
        {{ area?.label }}
    </div>
    <div class="cmps-cdk-flex-grow-1"></div>
    <div class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5">
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-flex-column cmps-cdk-font-size-10p"
            *ngIf="area?.doNotEvaluate !== true && area?.evaluatedBool === true"
        >
            <cmps-icon
                class="cmps-cdk-fill-blue-100"
                svgIcon="check-circle"
            ></cmps-icon>
            <span>LLM</span>
        </div>
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-flex-column cmps-cdk-font-size-10p"
            [cmpsTooltipTrigger]="area?.evaluatedReasoning"
            *ngIf="area?.doNotEvaluate !== true && area?.evaluatedBool !== true"
        >
            <cmps-icon
                class="cmps-cdk-fill-red-100"
                svgIcon="close-circle-outline"
            ></cmps-icon>
            <span>LLM</span>
        </div>
    </div>
</div>
